import { createTheme, palette } from '@dentalux/ui-library-core/constants'
import { MuiAlert, MuiButton, shadows, typography, MuiSwitch } from '@dentalux/ui-library-core/themes'

import MuiAutocomplete from './overrides/MuiAutocomplete'
import MuiCssBaseline from './overrides/MuiCssBaseline'
import MuiFormHelperText from './overrides/MuiFormHelperText'
import MuiFormLabel from './overrides/MuiFormLabel'
import MuiInputBase from './overrides/MuiInputBase'
import MuiStep from './overrides/MuiStep'
import MuiStepIcon from './overrides/MuiStepIcon'
import MuiStepLabel from './overrides/MuiStepLabel'
import MuiStepper from './overrides/MuiStepper'
import MuiTypography from './overrides/MuiTypography'

const theme = createTheme({
  typography,
  shadows,
  components: {
    MuiTypography,
    MuiButton,
    MuiSwitch,
    MuiStep,
    MuiCssBaseline,
    MuiStepIcon,
    MuiStepper,
    MuiStepLabel,
    MuiFormHelperText,
    MuiAutocomplete,
    MuiInputBase,
    MuiFormLabel,
    MuiAlert,
  },
  palette: {
    mode: 'light',
    ...palette,
  },
})

export default theme
